module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUVJREFUeNqU080rBVEYx/GZ23hJRFkpKclCSllKXlKUle5KeSkLStyN7sZ/YBaiRIosrpKSsCEbK6XYWJBSoiQ7G+S9y/fUT52muWY89ZnnqTnznDln5ri+7zsRkUArhjGHk+DNv2IKRXhCP46xELfBKibh4hR9uMUYDqIazGAQryhAFuuowT46sJyrwSwmVJsGj6hDE77QjRvtSYPHZQllGlyBzsASP1ClmetxgRR2kTYNRpzouFZeRBv21DhpZniI0SBP2XxOT/UVShLO/8NV/v5dY3mMhz6Vj6y6Fs/mddZQjDdUojmkQbXyqHIX8rFpGgwEBs9jXHVW679HO86sMSamvZDZUsqmSSFKcW7d39HrZ8wfmmsTTZMNnYN3bVwSl+jBIYYc65OERS/uVDdiS/WK/sJYpzGNFy1jGy32wyZ+BBgAcx8/sjashJ8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/speaker.png
// module id = OAeq
// module chunks = 3